import {Component, ViewChild} from '@angular/core';
import {IonicPage, NavController, NavParams, Refresher} from 'ionic-angular';
import {LoyaltyRewardsBarbershopPage} from "../loyalty-rewards-barbershop/loyalty-rewards-barbershop";
import {LoyaltyServiceProvider} from "../../providers/loyalty-service/loyalty-service";

@IonicPage()
@Component({
  selector: 'page-loyalty-rewards',
  templateUrl: 'loyalty-rewards.html',
})
export class LoyaltyRewardsPage {

  public shops: any;
  public loading: boolean;

  @ViewChild(Refresher) refresher: Refresher;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public loyaltyProvider: LoyaltyServiceProvider
  ) {
  }

  ionViewDidEnter() {
    this.loading = true;

    this.loyaltyProvider.getShopsWithLoyaltyPoints(localStorage.getItem('tuid')).then((shops) => {
      this.shops = shops;
      this.loading = false;
    })
  }

  openRewardsForShop(shop) {
    this.navCtrl.push(LoyaltyRewardsBarbershopPage, {shop: shop})
  }

  pullToRefresh(event) {
    this.loyaltyProvider.getShopsWithLoyaltyPoints(localStorage.getItem('tuid')).then((shops) => {
      this.shops = shops;
      this.refresher.complete();
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/loyalty-rewards/loyalty-rewards.ts